import React from 'react';
import _ from 'lodash';
import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';

const FormikInput = ({ field: { ...fields }, form: { touched, errors }, ...props }): React.ReactNode => {
    const {
        id,
        maxLength,
        isDefaultValue,
        multiline,
        className,
        hasObject = false,
        controlClassName,
        sx,
        noMaxLength,
        ...rest
    } = props;
    const error = Boolean(_.get(touched, fields?.name) && _.get(errors, fields?.name));
    const getError = () => {
        let errorString = errors;
        if (hasObject) fields?.name?.split('.').map((name) => (errorString = errorString[name]));
        return errorString;
    };
    return (
        <>
            {props?.inputlabel && <InputLabel>{props?.inputlabel}</InputLabel>}
            <FormControl fullWidth className={controlClassName} sx={sx}>
                {isDefaultValue ? (
                    <OutlinedInput
                        {...fields}
                        {...rest}
                        id={id}
                        className={className}
                        multiline={multiline}
                        error={error}
                        placeholder={props?.inputlabel}
                        autoComplete="off"
                        inputProps={{
                            maxLength: noMaxLength ? -1 : maxLength ? maxLength : 100,
                        }}
                    />
                ) : (
                    <OutlinedInput
                        {...fields}
                        {...rest}
                        id={id}
                        className={className}
                        placeholder={props?.inputlabel}
                        value={props.type === 'number' ? fields?.value || '' : fields?.value?.toString()?.trimStart()}
                        multiline={multiline}
                        error={error}
                        autoComplete="off"
                        inputProps={{
                            maxLength: noMaxLength ? -1 : maxLength ? maxLength : 100,
                        }}
                    />
                )}
                {error && (
                    <FormHelperText error>{error && (hasObject ? getError() : errors[fields?.name])}</FormHelperText>
                )}
            </FormControl>
        </>
    );
};

export default FormikInput;
